<template>
    <el-dialog title="Boost Produit" v-loading="loader" :visible.sync="display" width="80%">
        <span>Boosté les {{ items_selected }} produits selectionnés</span>
        <el-form class="row formActive" ref="form" :model="form">
            <div class="row mb-5 mt-1">
                <div class="col-4">
                    <el-form-item prop="popularity" label="Boost produit">
                        <el-input-number v-model="form.popularity.sort_man" controls-position="right" :min="0"></el-input-number>
                    </el-form-item>
                </div>
                <div class="col-4">
                    <el-form-item prop="popularity" label="Boost de nouveauté">
                        <el-input-number v-model="form.popularity.cpt_new" controls-position="right" :min="0"></el-input-number>
                    </el-form-item>
                </div>
                <div class="col-4">
                    <el-form-item prop="popularity" label="Durée nouveauté">
                        <el-input-number v-model="form.popularity.cpt_time" controls-position="right" :min="0"></el-input-number>
                    </el-form-item>
                </div>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-switch active-text="Syncronisé ?" v-model="form.sync" ></el-switch>
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            form: {
                popularity: {
                    sort_man: 0,
                    cpt_new: 0,
                    cpt_time: 0,
                },
                sync: false,
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        },
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            var popularity = this.form.popularity;
            var products = this.selected.map(v => v.id);
            this.loader = true;

            var datas = {
                products,
                popularity,
                sync: this.form.sync,
                mode: 'boost'
            };
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected

            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }

            axios
                .post('/products/bulk', datas)
                .then(r => {
                    this.$emit('saved', r);
                    this.$refs.form.resetFields();
                    this.display = false;
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        }
    }
};
</script>
